import Cookies from "js-cookie";
/**
 * Tools component
 **************************************************
 * Used for toggling navbar, modals and search
 */

document.addEventListener("alpine:init", () => {

	window.Alpine.data('tools', (options = {}) => ({
		isNavToggled: false,
		isSearchToggled: false,
		isScrolling: false,
		showModal: false,
		showAgeVerify: false,
		prevScrolling: false,
		navHeight: null,
		namespace: {
			root: 'ah',
			actions: {
				modal: 'hide-modal',
				ageVerify: 'hide-age-verify'
			}
		},
		init() {
			if( sessionStorage.getItem( this.getNamespace('modal') ) ){
				this.showModal = false;
			}else{
				this.showModal = options.showModal ?? false;
			}

			if( localStorage.getItem( this.getNamespace('ageVerify') ) ){
				this.showAgeVerify = false;
			}else{
				this.showAgeVerify = Boolean(options.showAgeVerify) ?? false;
			}

		},
		getNamespace( action ) {
			const ca = this.namespace.actions[ action ] ?? '';
			return `__${ this.namespace.root }__${ ca }`;
		},
 		isOverThreshold() {
			let top = document.querySelector('html').scrollTop;
			return top > 400;
		},
		toggleScrolling() {
			this.isScrolling = this.isOverThreshold();
		},
		toggleNavbar() {
			this.isNavToggled = !this.isNavToggled;
			this.isSearchToggled = false;

			if( this.isNavToggled ){
				this.prevScrolling = this.isScrolling;
				this.isScrolling = false;
			}else{
				this.isScrolling = this.prevScrolling;
			}

		},
		toggleSearch() {
			this.isSearchToggled = !this.isSearchToggled;
			this.isNavToggled = false;

			if( this.isSearchToggled ){
				this.$refs.searchInput.focus();
				this.prevScrolling = this.isScrolling;
				this.isScrolling = false;
			}else{
				this.isScrolling = this.prevScrolling;
			}

		},
		showBackdrop() {
			return this.isNavToggled || this.isSearchToggled || this.showModal;
		},
		confirmAge() {
			localStorage.setItem(this.getNamespace('ageVerify'), true);
			this.showAgeVerify = false;
		},
		reset() {
			if( this.showModal ){
				sessionStorage.setItem(this.getNamespace('modal'), true);
			}
			
			this.isNavToggled = this.isSearchToggled = this.showModal = false;
		}
	}));

});